<script lang="ts">
const GAP_PX = 4
</script>
<script setup lang="ts">
    import { storeToRefs } from 'pinia';
    import { COBROWSE_OVERLAY_CLASS } from '~/app/cobrowse/classes/CobrowseRecorder';
    import { estimateSelectListHeight } from '~/app/cobrowse/protocol';
    import { useCobrowseStore } from '~/stores/cobrowseStore';

    

    const { selectPreview } = storeToRefs(useCobrowseStore());

    const position = computed(() => {
        if (!selectPreview.value) {
            return null;
        }

        const { rect, options } = selectPreview.value;
        const listHeight = estimateSelectListHeight(options.length);
        const fitsBelow = rect.top + rect.height + GAP_PX + listHeight <= window.innerHeight;
        const width = Math.max(rect.width, 160);

        return {
            left: `${Math.max(0, Math.min(rect.left, window.innerWidth - width))}px`,
            top: `${fitsBelow ? rect.top + rect.height + GAP_PX : Math.max(0, rect.top - GAP_PX - listHeight)}px`,
            width: `${width}px`,
        };
    });
</script>

<template>
    <div
        v-if="selectPreview && position"
        :class="COBROWSE_OVERLAY_CLASS"
        class="pointer-events-none fixed inset-0 z-[2147482000]"
        aria-hidden="true"
    >
        <ul
            class="absolute max-h-64 min-w-40 overflow-y-auto rounded-lg border border-branding-light-grey bg-white py-1 text-sm shadow-popup animate-fade-in-up motion-reduce:animate-none"
            :style="position ?? undefined"
        >
            <li
                v-for="option in selectPreview.options"
                :key="option.value"
                class="truncate px-3 py-2 transition-colors duration-150"
                :class="{
                    'bg-primary text-white': option.value === selectPreview.highlightedValue,
                    'font-semibold text-primary': option.value === selectPreview.currentValue && option.value !== selectPreview.highlightedValue,
                }"
            >
                {{ option.label }}
            </li>
        </ul>
    </div>
</template>
